import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, ArrowRight, Scale, FileText } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-zinc-50" data-id="element-26">
      <div className="max-w-7xl mx-auto px-6" data-id="element-27">
        <div className="max-w-4xl mx-auto text-center" data-id="element-28">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white text-zinc-800 text-sm font-semibold mb-8 border border-zinc-200 shadow-sm" data-id="element-29">
            <ShieldCheck size={16} className="text-zinc-900" data-id="element-30" />
            <span data-id="element-31">Надійний юридичний захист</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-5xl lg:text-7xl font-extrabold tracking-tight text-zinc-900 mb-6 leading-[1.1]" data-id="element-32">
            Військові, кримінальні <br className="hidden md:block" data-id="element-33" />
            та цивільні справи
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-lg lg:text-xl text-zinc-500 mb-10 leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-34">
            Комплексний супровід військовослужбовців, призовників та їхніх
            родин. Від оскарження рішень ВЛК до захисту у кримінальних справах.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-35">
            <a href="#contact" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-zinc-900 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-zinc-800 transition-all hover:shadow-xl hover:shadow-zinc-900/10" data-id="element-36">
              Отримати консультацію
              <ArrowRight size={18} data-id="element-37" />
            </a>
            <a href="#services" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-white text-zinc-900 px-8 py-4 rounded-full text-base font-semibold border border-zinc-200 hover:border-zinc-300 hover:bg-zinc-50 transition-all" data-id="element-38">
              Всі послуги
            </a>
          </motion.div>
        </div>

        {/* Stats / Trust indicators */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.5
      }} className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-39">
          {[{
          icon: Scale,
          title: 'Законність',
          desc: 'Діємо виключно в рамках правового поля України'
        }, {
          icon: ShieldCheck,
          title: 'Конфіденційність',
          desc: 'Гарантуємо повну безпеку ваших даних та ситуації'
        }, {
          icon: FileText,
          title: 'Результативність',
          desc: 'Орієнтація на максимально позитивний результат для клієнта'
        }].map((item, i) => <div key={i} className="bg-white p-8 rounded-3xl border border-zinc-200 shadow-sm flex flex-col items-center text-center hover:border-zinc-300 transition-colors" data-id="element-40">
              <div className="w-12 h-12 rounded-full bg-zinc-100 flex items-center justify-center text-zinc-900 mb-5" data-id="element-41">
                <item.icon size={24} strokeWidth={1.5} data-id="element-42" />
              </div>
              <h3 className="font-bold text-zinc-900 mb-2 text-lg" data-id="element-43">
                {item.title}
              </h3>
              <p className="text-sm text-zinc-500 font-medium" data-id="element-44">{item.desc}</p>
            </div>)}
        </motion.div>
      </div>
    </section>;
}